export enum GraphicCategoryType {
  Heating = 0,
  Ventilation = 1,
  Cooling = 2,
  Other = 3,
}

export const GRAPHIC_CATEGORY_TYPES = [
  GraphicCategoryType.Heating,
  GraphicCategoryType.Ventilation,
  GraphicCategoryType.Cooling,
  GraphicCategoryType.Other,
];

export type GraphicPictureCategories = {
  categories: GraphicCategoryType[];
};
